// Auto-logout saat idle. Dipasang SEKALI per sesi di shell (setelah login). Karena logout
// me-reload halaman, listener/timer ini otomatis bersih tiap sesi — tak menumpuk antar-login.
// menit ≤ 0 → mati (kembalikan no-op).
export function startIdleLogout(menit: number, onTimeout: () => void): () => void {
  if (!menit || menit <= 0) return () => { /* mati */ };
  const ms = menit * 60_000;
  let timer = 0;
  const reset = (): void => { window.clearTimeout(timer); timer = window.setTimeout(onTimeout, ms); };
  const ev = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'] as const;
  ev.forEach((e) => window.addEventListener(e, reset, { passive: true }));
  reset();
  return () => { window.clearTimeout(timer); ev.forEach((e) => window.removeEventListener(e, reset)); };
}
